import commonService from './common-service';
import helperService from './helper';

class Auth {
  async login(username, password) {
    try {
      const resp = await commonService.postToServer('/Login', {
        username: username,
        password: password,
      });

      if (resp) {        
          helperService.setHeaders('Authorization', `Bearer ${resp?.token}`);
          return resp;        
      } else {
        throw new Error('Invalid User Credentials');
      }
    } catch (e) {
      const error = new Error(e.message);
      error.code=e.code;
      error.msg=e.msg;
      throw error;
    }
  }

  /***
   *
   * @param user {userName,password,userType,userRole,facility,department,firstName,lastName,email,phone,blocked}
   * @return {Promise<*>}
   */
  async createUser(user) {
    try {
      const resp = await commonService.postToServer('users', user);
      if (resp)
        return resp;
      else
        throw new Error('Invalid User Credentials');
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new Auth();
